import { useFormik } from 'formik';
import * as Yup from 'yup';
import useValidation from '../../validation/useValidation';
export default function useAssociationForm() {
  const { validateDateFrom, validateDateTo } = useValidation();
  const validationSchema = Yup.object().shape({
    associations: Yup.array().of(
      Yup.object().shape({
        recordTypes: Yup.array().of(
          Yup.object().shape({
            recordTypeId: Yup.string().required('record type is required'),
            from: validateDateFrom(),
            to: validateDateTo(),
          }),
        ),
      }),
    ),
  });
  const associationsForm: any = useFormik({
    initialValues: {
      parentEntityId: 0,
      entityAssociations: [
        {
          id: 0,
          childEntityId: null,
          relationshipType: null,
          preferenceNotes: null,
          isBidirectional: false,
          parentRoleType: null,
          childRoleType: null,
          disabled: false,
          associationRecordTypes: [
            {
              id: 0,
              dateFrom: null,
              dateTo: null,
              custodianProviderId: null,
              recordTypeId: null,
              disabled: false,
            },
          ],
        },
      ],
    },
    validateOnChange: true,
    validationSchema,
    onSubmit: (values) => { },
  });
  return { associationsForm };
}
